import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';

export default class HotelEventsEditRoute extends Route {
  @service declare access: Services['access'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (!this.access.can('events_holidays.author')) {
      this.transition.redirectToTab(transition, 'hotel.events');
    }
  }
}
